import { render, staticRenderFns } from "./custConvertListNew.vue?vue&type=template&id=f12ff9f0&scoped=true"
import script from "./custConvertListNew.vue?vue&type=script&lang=js"
export * from "./custConvertListNew.vue?vue&type=script&lang=js"
import style0 from "./custConvertListNew.vue?vue&type=style&index=0&id=f12ff9f0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f12ff9f0",
  null
  
)

export default component.exports